
export default function Login() {   
    
    window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}`)    
   
}